export const DEFAULT_CATEGORY_ACCENT = '#D92E2E'

export const SLIDER_ACCENT_GREEN = '#22a04a'

/** Kategori rengi yoksa varsayılan kırmızı */
export function categoryAccent(color?: string | null): string {
  const value = color?.trim()
  if (!value) return DEFAULT_CATEGORY_ACCENT
  if (/^#[0-9A-Fa-f]{3,8}$/.test(value)) return value
  if (value.startsWith('rgb')) return value
  return DEFAULT_CATEGORY_ACCENT
}

/** Manşet pagination rengi: sabit kategori rengi → slide kategorisi → spor yeşili → varsayılan */
export function resolveSliderAccent(
  fixedColor: string | null | undefined,
  slideCategoryColor: string | null | undefined,
  preset: 'red' | 'green' = 'red',
): string {
  if (fixedColor?.trim()) return categoryAccent(fixedColor)
  if (slideCategoryColor?.trim()) return categoryAccent(slideCategoryColor)
  if (preset === 'green') return SLIDER_ACCENT_GREEN
  return DEFAULT_CATEGORY_ACCENT
}
